module.exports = __webpack_public_path__ + "static/3-dc2c2d8ebbd1be092d7fa38899ddc531.svg";